/*Contactos*/
import React from 'react';
import styles from './Contact.module.css';
import { FaFacebookF, FaTwitter, FaInstagram, FaEnvelope } from 'react-icons/fa';

const Contact = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.info}>
          <h3>Facultad de Medicina</h3>
          <p>Universidad Autónoma Tomás Frías</p>
          <p>Dirección: Calle Hoyos #36, Potosí, Bolivia</p>
          <p>Email: med.uatf@gmail.com</p>
        </div>

        <div className={styles.socials}>
          <h4>Síguenos</h4>
          <div className={styles.icons}>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://med.uatf@gmail.com">
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>

      <div className={styles.copy}>
        © {new Date().getFullYear()} Facultad de Medicina - UATF. Todos los derechos reservados.
      </div>
    </footer>
  );
};

export default Contact;
